export enum EKYC_SINGPASS_RESPONSE {
  SUCCESS = 1,
  DATA_MISMATCH = 9992,
  INVALIDATE_DOC = 9993,
  FIRST_ATTEMPT = 9990,
  NO_LEFT_ATTEMPT = 9991,
  CONNECTION_FAILED = 9998,
  ALIAS_NAME_PRESENT = 8999,
  ACCOUNT_CREATION_FAILED = 8997,
  NOT_MEET_AGE_REQ = 8998
}

export const EKYC_PAGEFROM = {
  SETTINGS: "Settings",
  SENDMONEY: "Send Money",
  REGISTER: "Registration"
}

export enum SINGPASS_SETTING {
  PROCESSOR = 2075,
  SETTING_VAL = 22020,
  ACCOUNT_BLOCK = 19001,
  ACCOUNT_BLOCK_UNTIL = 19002,
  ACCOUNT_ADDRESS_UPDATED_WITH_SINGPASS = 24010,
  LAST_UPDATED_SINGPASS_KYC_DATE = 22030,
  LAST_UPDATED_ADDRESS_DATE = 240
}

export const EYC_VERIFICATION_FAILED_SEGMENTEVENT = {
  DATA_MISMATCH: "Data mismatch",
  UNACCEPTED_DOC: "Unaccepted document",
  CONNECTION_FAILED: "Connection fail",
  NO_LEFT_ATTEMPT: "Secound attempt",
  ALIAS_NAME_PRESENT:"Alias name present",
  UNDERAGE : "Underage",
  ACCOUNT_PROFILE_CREATION_FAILED: "Profile creation"
}


// WEBPACK FOOTER //
// ./src/model/models/ekyc-singpass/ekyc-singpass.model.ts